export default "__VITE_ASSET__DtTl8k76__"